module.exports = __webpack_public_path__ + "static/media/c15-4g-connect.f9ae0e8b.png";